// eslint-disable-next-line import/prefer-default-export
export const MAX_FAILED_ATTEMPTS = 5;
export const DAYS_TO_KEEP_LOGS = 60;
